import React from "react";

import { ReactComponent as AskFellowIcon } from "~/nav/icons/ask-fellow-outline.svg";

import { useAskFellowActionContext } from "./AskFellowActionContext";
import { ControlButton } from "./SharedComponents";

import styles from "./FloatingAskFellowButton.module.css";

export default function FloatingAskFellowButton() {
	const { getActionHandler } = useAskFellowActionContext();

	const onClick = React.useMemo(() => {
		return getActionHandler();
	}, [getActionHandler]);

	return (
		<ControlButton className={styles.askFellowButton} innerClassName={styles.askFellowButtonInner} onClick={onClick}>
			<span className={styles.askFellowButtonText}>
				<AskFellowIcon className={styles.askFellowIcon} />
				Ask Fellow
			</span>
		</ControlButton>
	);
}
